import { forwardRef, createElement, createContext, ElementType } from 'react';
import { AnchorPropInterface, LinkProviderInterface } from './types/propsTypes';

const Anchor = forwardRef<HTMLAnchorElement, AnchorPropInterface>(
  ({ children, ...restProps }: AnchorPropInterface, ref) => createElement('a', { ...restProps, ref: ref }, children),
);
Anchor.displayName = 'Anchor';

const LinkContext = createContext<{ element: ElementType; isNext14: boolean }>({ element: Anchor, isNext14: false });

const LinkProvider = ({ element, isNext14 = false, children }: LinkProviderInterface) => (
  <LinkContext.Provider value={{ isNext14, element }}>{children}</LinkContext.Provider>
);

export { LinkProvider, Anchor, LinkContext };
